import { GdsAggregationServiceBaggage, GdsAggregationServiceGroup, GdsAggregationServiceMeal } from '../../../../types';

export const groupGdsSelectedServices = <T extends GdsAggregationServiceBaggage | GdsAggregationServiceMeal>(
	serviceGroup: GdsAggregationServiceGroup
) => {
	const servicesMap = new Map<
		string,
		{
			service: T;
			count: number;
		}
	>();

	serviceGroup.selectedServices.forEach(service => {
		const serviceRfics = (service.service as T).rfics;

		servicesMap.set(serviceRfics, {
			service: servicesMap.get(serviceRfics)?.service ?? (service.service as T),
			count: (servicesMap.get(serviceRfics)?.count ?? 0) + service.count
		});
	});

	const selectedServices: {
		service: T;
		count: number;
	}[] = [];

	servicesMap.forEach(services => {
		selectedServices.push(services);
	});

	return selectedServices;
};

export const isVipSubTypeSelected = (group: GdsAggregationServiceGroup, subType: string): boolean => {
	return group.selectedServices.some(selected => {
		if (!selected.service || !('subType' in selected.service)) {
			return false;
		}

		return selected.service.subType === subType;
	});
};
